import { Link } from "react-router-dom";
import { fa_currency, fa_number } from "../../utils/PersianNum";
import { useDispatch } from "react-redux";
import { addToCart } from "../../Redux/Slices/cartSlice";

function ProductItem({prod}) {
  const dispatch = useDispatch();
  const handleAddToCart = () => {
      dispatch(addToCart({ product: prod, quantity: 1 }));
  };

  return (
    <div className="col">
      <div className="card shadow-sm">
        <Link to={`/product/${prod.id}/${prod.name.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').toLowerCase()}`}>
            {prod.sale_price && prod.sale_price > 0 && prod.price > 0 &&
            <div
              className="badge py-2 text-white position-absolute"
              style={{ top: "0.5rem", right: "0.5rem" }}
            >
              {fa_number(Math.round(((prod.price - prod.sale_price)/prod.price)*100))}٪ تخفیف
            </div>}
          <img
            className="card-img-top bg-dark cover"
            height="200"
            alt=""
            src={prod.images}
          />
        </Link>
        <div className="card-body">
          <h5 className="card-title text-center text-dark text-truncate">
            {prod.name}
          </h5>
          <p className="card-text text-center text-muted mb-0">
            {prod.price === '0' ? "تماس بگیرید" :
            prod.sale_price && prod.sale_price > 0 ? 
              <><del>{fa_currency(+prod.price)}</del> {fa_currency(+prod.sale_price)}تومان</> 
              :
              `${fa_currency(+prod.price)}تومان`
            }
          </p>
          <div className="d-grid d-block">
            <button className="btn btn-outline-dark mt-3" onClick={handleAddToCart} disabled={prod.price === '0'}>
                <i className="fas fa-cart-plus"></i> اضافه به سبد
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductItem;
